import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  LoadLocalization,
  LocalizationActionsEnum,
  SetLocaleSuccess,
} from '../actions';
import { ILocalizationData } from '../localization.data';
import { List } from 'immutable';

export const FEATURE_NAME = 'localization';

export interface ILocalizationState extends ILocalizationData {
  loading: boolean;
  loaded: boolean;
}

export const localizationInitialState: ILocalizationState = {
  loading: false,
  loaded: false,
  defaultLanguage: null,
  currentLocale: null,
  supportedLanguages: List([]),
  country: null,
};

export const reducerFn = handleActions(
  {
    [LocalizationActionsEnum.INIT_LOCALIZATION]: function (
      state: ILocalizationState
    ) {
      return {
        ...state,
        loading: true,
      };
    },
    [LocalizationActionsEnum.LOAD_LOCALIZATION]: function (
      state: ILocalizationState,
      { payload }: LoadLocalization
    ) {
      return {
        ...state,
        ...payload,
      };
    },
    [LocalizationActionsEnum.LOAD_LOCALIZATION_SUCCESS]: function (
      state: ILocalizationState
    ) {
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    },
    [LocalizationActionsEnum.SET_LOCALE_SUCCESS]: function (
      state: ILocalizationState,
      { payload }: SetLocaleSuccess
    ) {
      return {
        ...state,
        currentLocale: payload.locale,
      };
    },
  } as any,
  localizationInitialState
);

// required for AOT
export function localizationReducer(
  state: ILocalizationState = localizationInitialState,
  action: any
) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<ILocalizationState>(FEATURE_NAME);

export const isLoading = createSelector(
  selectFeature,
  (state: ILocalizationState) => state.loading
);

export const isLoaded = createSelector(
  selectFeature,
  (state: ILocalizationState) => state.loaded
);

export const getCurrentLocale = createSelector(
  selectFeature,
  (state: ILocalizationState) => state.currentLocale
);

export const getCountry = createSelector(
  selectFeature,
  (state: ILocalizationState) => state.country
);

export const getDefaultLanguage = createSelector(
  selectFeature,
  (state: ILocalizationState) => state.defaultLanguage
);

export const getSupportedLanguages = createSelector(
  selectFeature,
  (state: ILocalizationState) => state.supportedLanguages
);
